export function forceBrowserDownload(uri, filename) {
  var encodedUri = encodeURI(uri);
  var link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename);
  if (navigator.userAgent.indexOf('Firefox') >= 0) {
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    link.click();
  }
}



// WEBPACK FOOTER //
// ./app/utils/download.js